import service from "./service.js";

export const userService = {
  login,
  logout,
  register,
  deleteUser,
  verifyEmail,
  forgotPassword,
  generatePassword,
  loginMFA,
  userInfo,
  updateInfo,
  updateAvatar,
  adminGetAllUser,
  adminGetAllUserMFA,
  adminChangeUserPwd,
  adminDisable2FAforUser,
  adminChangeStatusOfUser,
  adminResendEmailForUser,
  getListRole,
  getRuleOfRole,
  createRole,
  editRole,
  updateAccessRule,
  editRule,
  editGroupRole,
  resetPasswordUser,
  getDataFromSearch
};
function getDataFromSearch({
  keyword
  // limit = "500",
  // page = "1",
  // sort = "id",
  // sortType = "DESC",
  // filter = ""
}) {
  return new Promise((resolve, reject) => {
    service
      .get(`/getdatafeomseach?keword=${keyword}`)
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error.message);
      });
  });
}
function resetPasswordUser(id) {
  return new Promise((resolve, reject) => {
    service
      .post("/v1/reset-password/chưacho", {
        id: id
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}

function editGroupRole(obj) {
  return new Promise((resolve, reject) => {
    service
      .post("/v1/role/group-feature/save", {
        group_feature: obj
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}
function editRule(obj) {
  return new Promise((resolve, reject) => {
    service
      .post("/v1/role/feature/save", {
        feature: obj
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}
function updateAccessRule(role_id, feature_id, access) {
  return new Promise((resolve, reject) => {
    service
      .post("/v1/role/update-access", {
        role_id: role_id,
        feature_id: feature_id,
        access: access
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}
function editRole(name_role, description_role, id) {
  return new Promise((resolve, reject) => {
    service
      .post("/v1/role", {
        name: name_role,
        description: description_role,
        id: id
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}
function createRole(body) {
  return new Promise((resolve, reject) => {
    service
      .post("/v1/role", { role: body })
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}
function getRuleOfRole(id) {
  return new Promise((resolve, reject) => {
    service
      .get("/v1/role/rule-of-role?role_id=" + id)
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}
function getListRole() {
  return new Promise((resolve, reject) => {
    service
      .get("/v1/role")
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}
function login(username, password) {
  return new Promise((resolve, reject) => {
    service
      .post("/v1/auth/login", {
        username: username,
        password: password
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            service.setAuth(res.data.data);
            resolve(res.data.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}

function logout() {
  return service.post("/v1/auth/logout", null);
}

function loginMFA(email, password, mfaCode) {
  return new Promise((resolve, reject) => {
    service
      .post("/public/account/verify2FA", {
        email: email,
        password: password,
        token: mfaCode
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            localStorage.setItem("user", JSON.stringify(res.data.data));
            service.setAuth(res.data.data);
            resolve(res.data.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error.message);
      });
  });
}

function register(body) {
  return new Promise((resolve, reject) => {
    service
      .post("/v1/user/", { ruser: body })
      .then(res => {
        if (res.data.status) {
          resolve(res.data);
        } else {
          reject(res.data.message);
        }
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

function deleteUser(user_id) {
  return new Promise((resolve, reject) => {
    service
      .post("/v1/user/delete", { user_id: user_id })
      .then(res => {
        if (res.data.status) {
          resolve(res.data);
        } else {
          reject(res.data.message);
        }
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

function verifyEmail(body) {
  return new Promise((resolve, reject) => {
    service
      .post("/public/account/verify", body)
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            localStorage.setItem("user", JSON.stringify(res.data.data));
            service.setAuth(res.data.data);
            resolve(res.data.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error.message);
      });
  });
}

function forgotPassword(email) {
  return new Promise((resolve, reject) => {
    service
      .post("/public/account/password/forgot", {
        email: email
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error.message);
      });
  });
}

function generatePassword(token) {
  return new Promise((resolve, reject) => {
    service
      .post("/public/account/password/forgot/generate", {
        token: token
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error.message);
      });
  });
}

function userInfo() {
  return new Promise((resolve, reject) => {
    service
      .get("/v1/auth/info")
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error.message);
      });
  });
}

function updateInfo(body) {
  return new Promise((resolve, reject) => {
    service
      .post("/v1/auth/info", { newuser: body })
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.data);
        }
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

function updateAvatar(files) {
  return new Promise((resolve, reject) => {
    service
      .postFormData("/v1/upload/avatar", files)
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.data);
        }
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

function adminGetAllUser({
  limit = "5",
  page = "1",
  sort = "id",
  sortType = "DESC",
  filter = ""
}) {
  return new Promise((resolve, reject) => {
    service
      .get(
        `/v1/user?limit=${limit}&page=${page}&sort=${sort}&sortType=${sortType}&filter=${filter}`
      )
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res);
        }
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

function adminGetAllUserMFA({
  limit = "500",
  page = "1",
  sort = "id",
  sortType = "DESC",
  filter = ""
}) {
  return new Promise((resolve, reject) => {
    service
      .get(
        `/admin/security/user?limit=${limit}&page=${page}&sort=${sort}&sortType=${sortType}&filter=${filter}`
      )
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error.message);
      });
  });
}

function adminChangeUserPwd(userid) {
  return new Promise((resolve, reject) => {
    service
      .post("/admin/profile/changeuserpwd", {
        userid: userid
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error.message);
      });
  });
}

function adminDisable2FAforUser(userid) {
  return new Promise((resolve, reject) => {
    service
      .post("/admin/security/disable2FAforUser", {
        userid: userid
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error.message);
      });
  });
}

function adminChangeStatusOfUser(userid, status) {
  return new Promise((resolve, reject) => {
    service
      .post("/admin/user/status/modify", {
        userid: userid,
        status: status
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error.message);
      });
  });
}

function adminResendEmailForUser(email) {
  return new Promise((resolve, reject) => {
    service
      .post("/admin/user/email/resend", {
        email: email
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data.status) {
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        } else {
          reject(res.statusText);
        }
      })
      .catch(error => {
        reject(error.message);
      });
  });
}
